module.exports = __webpack_public_path__ + "static/media/icon-play-button.47eaa2c2.svg";